// @ts-nocheck

import basketSanitize from './basketSanitize';

const basketSetLoadingOk = (state, action, globalState) => {
  let nextState = basketSanitize(state, action, globalState);

  nextState = { ...nextState, loading: false };

  return nextState;
};

export default basketSetLoadingOk;
